import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/context/AuthContext";
import { fetcher } from "@/lib/api";

// Titik merah memakai kunci query yang sama dengan lonceng, jadi satu permintaan notifikasi
// melayani lonceng, menu, submenu, dan tombol sekaligus.
export function useUnreadNotifications() {
  const { me } = useAuth();
  const generic = !!me?.platform_role || !!me?.reseller;
  const aktif = generic || !!me?.school_permissions?.includes("feed:read");
  const endpoint = generic ? "/notifications" : "/school/notifications";
  const q = useQuery({
    queryKey: ["notifications", endpoint],
    queryFn: () => fetcher(`${endpoint}?limit=30`),
    refetchInterval: 60000,
    enabled: aktif,
  });
  return (q.data?.notifications ?? []).filter((n) => !n.read_at);
}

// Tautan notifikasi menunjuk halaman tujuan. Menu yang ditandai adalah menu terpanjang yang
// mencakup tautan itu, supaya "Langganan" tidak ikut menyala hanya karena "Ringkasan" punya notif.
export function menuBertanda(nav, belumDibaca) {
  const hasil = new Map();
  for (const n of belumDibaca) {
    if (!n.link) continue;
    const cocok = nav
      .filter((m) => n.link === m.to || (!m.end && n.link.startsWith(`${m.to}/`)))
      .sort((a, b) => b.to.length - a.to.length)[0];
    if (!cocok) continue;
    hasil.set(cocok.to, (hasil.get(cocok.to) || 0) + 1);
  }
  return hasil;
}

export function ActionDot({ show, testId, label = "Ada aktivitas yang butuh tindakan", className = "" }) {
  if (!show) return null;
  return (
    <span role="img" aria-label={label} title={label}
      className={`inline-block h-2 w-2 shrink-0 rounded-full bg-[#E11D2E] ${className}`}
      data-testid={testId} />
  );
}
